import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import fingerprintService from './services/fingerprintService'
import { getCompleteDeviceInfo, resetPageStartTime } from './services/deviceInfoService'

const app = createApp(App)

app.config.globalProperties.$fingerprint = fingerprintService
app.config.globalProperties.$deviceInfo = {
  getCompleteDeviceInfo,
}

router.afterEach(() => {
  resetPageStartTime()
})

fingerprintService.getFingerprint().catch(() => {
  // 指纹预热失败时静默回退，避免影响页面启动
})

app.use(router).mount('#app')
